import { singleton } from "tsyringe";
import { IPagination } from "components/elements/InfiniteScroll";

import BaseAdminApi from "./BaseAdminApi";
import CorporationSheetResponseResource from "common/resources/CorporationSheet/CorporationSheetResponseResource";
import CorporationSheetCreateRequestResource from "common/resources/CorporationSheet/CorporationSheetCreateRequestResource";
import CorporationSheetAdminCreateMinimalRequestResource from "common/resources/CorporationSheet/CorporationSheetAdminCreateMinimalRequestResource";
import CorporationSheetLightResponseResource from "common/resources/CorporationSheet/CorporationSheetLightResponseResource";

@singleton()
export default class CorporationApi extends BaseAdminApi {
	private baseurl = `${this.apiUrl}/corporations`;

	public getCorporationSheetById(id: string) {
		const url = this.baseurl.concat(`/${id}`);
		return this.getRequest<CorporationSheetResponseResource>(url);
	}

	public getCorporationSheetByCorporationId(id: string) {
		const url = this.baseurl.concat(`/corporation-id/${id}`);
		return this.getRequest<CorporationSheetResponseResource>(url);
	}

	public getCorporationSheetsByOfficeId(officeId: string, pagination: IPagination, search?: string | null) {
		const urlParams = new URLSearchParams();
		urlParams.append("_take", pagination.take.toString());
		urlParams.append("_skip", pagination.skip.toString());
		search && urlParams.append("_search", search ?? "");

		const url = this.baseurl.concat(`/office/${officeId}?${urlParams.toString()}`);
		return this.getRequest<CorporationSheetResponseResource[]>(url);
	}

	public countByOfficeId(officeId: string) {
		const url = this.baseurl.concat(`/office/${officeId}/count`);
		return this.getRequest<{ count: number }>(url);
	}

	public postAsCreator(corporation: CorporationSheetCreateRequestResource, creatorId: string) {
		const url = this.baseurl.concat(`/creator/${creatorId}`);
		return this.postRequest<CorporationSheetLightResponseResource>(url, { ...corporation });
	}

	public createMinimalCorporation(resource: CorporationSheetAdminCreateMinimalRequestResource, creatorId: string) {
		const url = this.baseurl.concat(`/minimal/creator/${creatorId}`);
		return this.postRequest<CorporationSheetLightResponseResource>(url, { ...resource });
	}
}
